var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lm-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":_vm.type,"msg":_vm.msg},on:{"close":function($event){_vm.show = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }